import React from 'react'
import { item_church } from '../dataApi';

const LocationChurch = () => {
    return (
        <div className="container-fluid py-5 my-5 px-5">
            <div className="w-full flex flex-wrap rounded-xl border shadow-md ">
                <div className=" w-full my-5 mx-5 translatable">
                    {item_church.localisation2}
                </div>

                <div className=" w-full my-5 mx-5 translatable">
                    {item_church.localisation1}
                </div>
            </div>
        </div>
    )
}

export default LocationChurch;
